<template>
    <div class='checkingSet'>
        <div class="checkingSet_wrap">
            <div class="checkingSet_title">
                <ul class="key_list">
                    <li class="conditions_list_item">
                        <span class="icon_red">*</span><span class="icon_text">类型</span>
                        <el-input v-model="search.type" placeholder="请输入" readonly></el-input>
                    </li>
                    <li class="conditions_list_item">
                        <span class="icon_red">*</span><span class="icon_text">名称</span>
                        <el-input v-model="search.name" placeholder="请输入" clearable></el-input>
                    </li>
                </ul>
                <ul class="key_list_b">
                    <li class="conditions_list_item">
                        <span class="span_title">备注：</span>
                        <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="search.remarks">
                        </el-input>
                    </li>
                    <li class="conditions_list_item">
                        <span class="span_title">申请人：</span>
                        <div class="radio_style">
                            <el-radio v-model="search.applyType" label="1">默认全部申请人</el-radio>
                            <el-radio v-model="search.applyType" label="2">条件选择，申请人可配置</el-radio>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="checkingSet_content" v-if="search.applyType=='1'">
                <div class="checkingSet_content_title" style="min-width:70px;">
                    <span class="xing">*</span>
                    <span>审批人：</span>
                </div>
                <div class="checkingSet_content_wrap">
                    <ul>
                        <li class="wrap_item" v-for="(item,index) in search.list" @click="itemClick(item,index)">
                            <div class="all">
                                <div class="top">
                                    <div class="top_left">
                                        <i class="iconfont icon-ren-01"></i>
                                        <span>审批人</span>
                                    </div>
                                    <div class="top_right" v-if="index!==0" @click.stop="delectList(index)">
                                        <i class="iconfont icon-guanbi"></i>
                                    </div>
                                </div>
                                <div class="bottom">
                                    <div class="bottom_left" v-if="item.employeeRole=='EMPLOYEE'&&item.checkEmployeeIds.length==0">请选择审批人</div>
                                    <div class="bottom_left" v-if="item.employeeRole=='EMPLOYEE'&&item.checkEmployeeIds.length>0&&item.checkType=='AND'">{{item.checkEmployeeIds.length}}人会签</div>
                                    <div class="bottom_left" v-if="item.employeeRole=='EMPLOYEE'&&item.checkEmployeeIds.length>0&&item.checkType=='OR'">{{item.checkEmployeeIds.length}}人或签</div>
                                    <div class="bottom_left" v-if="item.employeeRole=='ROLE'&&!item.stationId">请选择审批人</div>
                                    <div class="bottom_left" v-if="item.employeeRole=='ROLE'&&item.stationId&&item.checkType=='AND'">{{item.stationName}}会签</div>
                                    <div class="bottom_left" v-if="item.employeeRole=='ROLE'&&item.stationId&&item.checkType=='OR'">{{item.stationName}}或签</div>
                                    <div class="bottom_right">
                                        <i class="iconfont icongengduo"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="more">
                                <img src="../../assets/xiayige.png" alt="">
                            </div>
                        </li>
                        <li>
                            <div class="wrap_item_add">
                                <img src="../../assets/tianjia.png" alt="">
                                <img src="../../assets/jia.png" alt="" class="iconfont" @click="addList">
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="dbcheckingSet_content" v-if="search.applyType=='2'">
                <div class="checkingSet_content_title" style="min-width:70px;">
                    <span class="xing">*</span>
                    <span>审批人：</span>
                </div>
                <div class="checkingSet_content_wrap">
                    <div class="content_wrap_button" @click="addCondition">添加条件</div>
                    <div class="content_wrap_button_line" v-if="search.checkJson.length>1">
                        <img src="../../assets/xiayige.png" alt="">
                    </div>
                    <div style="height:2px;background:#CACACA;margin:0 auto;" :style="'width:' + itemWidth + 'px'" v-if="search.checkJson.length>1"></div>
                    <div style="display: flex;">
                        <div class="content_wrap_item" v-for="(item,index) in search.checkJson" :key="index">
                            <ul>
                                <li>
                                    <div class="button_line">
                                        <img src="../../assets/xiayige.png" alt="">
                                    </div>
                                    <div class="wrap_item" @click="conditionClick(item,index)">
                                        <div class="all">
                                            <div class="top">
                                                <div class="top_left">
                                                    <i class="iconfont icon-candan-01"></i>
                                                    <div class="input_text1" v-if="item.edititle">
                                                        <input maxlength="8" @blur="okText(index)" ref="inputFocus" :value="item.conditionRemarks"></input>
                                                    </div>
                                                    <div class="input_text" v-else>
                                                        <span>{{item.conditionRemarks}}</span>
                                                    </div>
                                                    <i class="iconfont icon-bianji-01" @click.stop="editText(index)"></i>
                                                </div>
                                                <div class="top_right" v-if="index!==0" @click.stop="delectTable(index)">
                                                    <i class="iconfont icon-guanbi"></i>
                                                </div>
                                            </div>
                                            <div class="bottom">
                                                <div class="bottom_left" v-if="item.employeeIds.length==0">请选择申请人</div>
                                                <div class="bottom_left" v-else>申请人为：{{item.employeeIdNames.join("、")}}</div>
                                                <div class="bottom_right">
                                                    <i class="iconfont icongengduo"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="more">
                                            <img src="../../assets/xiayige.png" alt="">
                                        </div>
                                    </div>
                                </li>
                                <li class="wrap_item" v-for="(item1,index1) in item.list" @click="itemClick(item1,index,index1)">
                                    <div class="all">
                                        <div class="top">
                                            <div class="top_left">
                                                <i class="iconfont icon-ren-01"></i>
                                                <span>审批人</span>
                                            </div>
                                            <div class="top_right" v-if="index1!==0" @click.stop="delectList(index,index1)">
                                                <i class="iconfont icon-guanbi"></i>
                                            </div>
                                        </div>
                                        <div class="bottom">
                                            <div class="bottom_left" v-if="item1.employeeRole=='EMPLOYEE'&&item1.checkEmployeeIds.length==0">请选择审批人</div>
                                            <div class="bottom_left" v-if="item1.employeeRole=='EMPLOYEE'&&item1.checkEmployeeIds.length>0&&item1.checkType=='AND'">{{item1.checkEmployeeIds.length}}人会签</div>
                                            <div class="bottom_left" v-if="item1.employeeRole=='EMPLOYEE'&&item1.checkEmployeeIds.length>0&&item1.checkType=='OR'">{{item1.checkEmployeeIds.length}}人或签</div>
                                            <div class="bottom_left" v-if="item1.employeeRole=='ROLE'&&!item1.stationId">请选择审批人</div>
                                            <div class="bottom_left" v-if="item1.employeeRole=='ROLE'&&item1.stationId&&item1.checkType=='AND'">{{item1.stationName}}会签</div>
                                            <div class="bottom_left" v-if="item1.employeeRole=='ROLE'&&item1.stationId&&item1.checkType=='OR'">{{item1.stationName}}或签</div>
                                            <div class="bottom_right">
                                                <i class="iconfont icongengduo"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="more">
                                        <img src="../../assets/xiayige.png" alt="">
                                    </div>
                                </li>
                                <li>
                                    <div class="wrap_item_add">
                                        <img src="../../assets/tianjia.png" alt="">
                                        <img src="../../assets/jia.png" alt="" class="iconfont" @click="addList(index)">
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <el-drawer title="我是标题" v-if="drawer" :wrapperClosable="false" :visible.sync="drawer" :direction="direction" :with-header="false" size="40%">
            <div class="drawer">
                <ul class="drawer_text">
                    <li class="drawer_text_item">
                        <div class="name">
                            <span>审批类型：</span>
                        </div>
                        <div>
                            <template>
                                <el-radio v-model="dataList.employeeRole" label="EMPLOYEE" @change="radioClick">指定审批人</el-radio>
                                <el-radio v-model="dataList.employeeRole" label="ROLE" @change="radioClick">指定岗位</el-radio>
                            </template>
                        </div>
                    </li>
                    <li class="drawer_text_item">
                        <div class="name" v-if="dataList.employeeRole=='EMPLOYEE'">
                            <span>审批人：</span>
                            <div class="staffmsg" style="" @click="departpopshow=!departpopshow">
                                <div class="staffmsg_ipt">{{doorsName}}</div>
                                <div class="departpop" v-show="departpopshow">
                                    <el-tree :default-expand-all="true" :data="departmentList" :props="defaultProps" @node-click="handleNodeClick">
                                        <span class="custom-tree-node" slot-scope="{ node,data}">
                                            <div>
                                                <img class="tree-icon" v-if="data.labelName=='区'" src="../../assets/icon/quyu.png" alt />
                                                <img class="tree-icon" v-if="data.labelName=='店'" src="../../assets/icon/dian.png" alt />
                                                <img class="tree-icon" v-if="data.labelName=='组'" src="../../assets/icon/zu.png" alt />
                                                <span>{{ data.name }}</span>
                                            </div>
                                        </span>
                                    </el-tree>
                                </div>
                            </div>
                            <el-select placeholder="请选择人员" v-model="prsonsId" @change="addApprover" @visible-change="getPrson(true)">
                                <el-option v-for="(item,index) in personList" :key="index" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </div>
                        <div class="name" v-else>
                            <span>岗位：</span>
                            <el-select placeholder="请选择岗位" v-model="dataList.stationId" @change="addStations">
                                <el-option v-for="(item,index) in stationList" :key="index" :label="item.name" :value="item.roleId"></el-option>
                            </el-select>
                        </div>
                        <div class="val" v-if="dataList.employeeRole=='EMPLOYEE'">
                            <div class="val_item" v-for="(items,index) in dataList.approverList" :key="index">
                                <span>{{items}}</span>
                                <img src="../../assets/shanchu.png" alt="" class="val_item_img" @click="deleteApprover(index)">
                            </div>
                        </div>
                    </li>
                    <li class="drawer_text_item">
                        <div class="name">
                            <span>多人审批时，采用的审批方式：</span>
                        </div>
                        <div>
                            <template>
                                <el-radio v-model="dataList.checkType" label="AND">会签（需所有审批人同意）</el-radio>
                                <el-radio v-model="dataList.checkType" label="OR">或签(一名审批人同意或拒绝即可)</el-radio>
                            </template>
                        </div>
                    </li>
                    <li class="drawer_text_item">
                        <div class="name">
                            <span>审批人为空或状态不正常时：</span>
                        </div>
                        <div>
                            <template>
                                <el-radio v-model="dataList.employeeIfNull" label="AGREE">自动通过</el-radio>
                                <el-radio v-model="dataList.employeeIfNull" label="DISAGREE">自动转交给指定人员</el-radio>
                            </template>
                        </div>
                    </li>
                    <li class="drawer_text_item">
                        <div style="height:30px;display:flex;align-items:center">
                            <div class="staffmsg" style="" @click="departpopshow1=!departpopshow1" v-show="dataList.employeeIfNull=='DISAGREE'">
                                <div class="staffmsg_ipt">{{dataList.undoorsName}}</div>
                                <div class="departpop" v-show="departpopshow1">
                                    <el-tree :default-expand-all="true" :data="undepartmentList" :props="defaultProps" @node-click="UnhandleNodeClick">
                                        <span class="custom-tree-node" slot-scope="{ node,data}">
                                            <div>
                                                <img class="tree-icon" v-if="data.labelName=='区'" src="../../assets/icon/quyu.png" alt />
                                                <img class="tree-icon" v-if="data.labelName=='店'" src="../../assets/icon/dian.png" alt />
                                                <img class="tree-icon" v-if="data.labelName=='组'" src="../../assets/icon/zu.png" alt />
                                                <span>{{ data.name }}</span>
                                            </div>
                                        </span>
                                    </el-tree>
                                </div>
                            </div>
                            <div>
                                <el-select placeholder="请选择人员" v-show="dataList.employeeIfNull=='DISAGREE'" v-model="dataList.adminId" @visible-change="ungetPrson(true)">
                                    <el-option v-for="(item,index) in unpersonList" :key="index" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>

                    </li>
                </ul>
                <div class="btns">
                    <div class="btn_left" @click="drawer=false">取消</div>
                    <div class="btn_right" @click="okClick">确定</div>
                </div>
            </div>
        </el-drawer>
        <!--选择考勤人员-->
        <el-dialog :before-close='handleClose' :visible.sync="drawer2" v-if="drawer2" width="490px">
            <div class="out1">
                <div class="title_text">
                    <div class="text_left">
                        <span>条件名称：{{conditionItem.conditionRemarks}}</span>
                    </div>
                    <div class="text_right">
                        <span>优先级{{conditionIndex+1}}</span>
                        <el-tooltip class="item" effect="dark" content="首先匹配“优先级1”的条件。如果匹配成功则审批单发送给该条件下的审批人；如果匹配不成功则继续进行匹配下一优先级的条件。" placement="top">
                            <i class="iconfont icon-tixing" style="color:#ff8000;font-size:20px;"></i>
                        </el-tooltip>
                    </div>
                </div>
                <div class="title_text" style="margin:0">
                    <div class="text_left">
                        <span>请选择申请人：</span>
                    </div>
                </div>
                <div class="tree-title">
                    <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                    <div>已添加{{employeeIds.length}}人</div>
                </div>
                <div class="tree_out">
                    <el-tree class="filter-tree" :data="attendancePerson" :props="defaultProps1" default-expand-all :filter-node-method="filterNode" @node-click="choicePerson" ref="tree">
                    </el-tree>
                    <!--已选考勤人员-->
                    <div class="selected">
                        <div class="selected-item" v-for="(item,index) in employeeIds" :key="index"><span style="width: 160px;">{{item.name}}</span><i @click="deleteAttendancePerson(index)" class="iconfont icon-guanbi"></i></div>
                    </div>
                </div>
            </div>
            <!--取消、确定按钮-->
            <div class="dialog-foot">
                <button class="foot-cancel" @click="drawer2=false">取消</button>
                <button class="foot-save" @click="conditionOkClick">确定</button>
            </div>
        </el-dialog>
        <div v-if="search.applyType=='1'||search.checkJson.length<=6">
            <div class="submitOk" @click="saveChecking">保存</div>
        </div>
        <div :style="'width:' + (itemWidth+400) + 'px'" v-if="search.applyType=='2'&&search.checkJson.length>6">
            <div class="submitOk" @click="saveChecking">保存</div>
        </div>
    </div>
</template>

<script>
import {
    addCheck,
    queryDepartment,
    queryEmployeeNameByStoreId,
    find,
    queryType,
    queryDetail,
    updateSet
} from "../../api/checkingIn";
import { departmentFind, employeeQuery } from "@/api/manageCenter";
import { departmentFind1 } from "@/api/login";

export default {
    data() {
        return {
            setId: parseInt(sessionStorage.getItem("setId")),
            //申请人员树配置选项
            defaultProps1: {
                children: "child",
                label: "name"
            },
            employeeIds: [],
            attendancePerson: {},
            filterText: "",
            itemWidth: 0,
            defaultProps: {
                children: "child"
            },
            departpopshow: false,
            departpopshow1: false,
            departmentId: "", //部门id
            departmentname: "", //部门名称
            //条件申请人
            conditionPrsonsId: "",
            conditionPrsonsName: "",
            //审批人
            doorsId: "",
            doorsName: "请选择部门",
            prsonsId: "",
            prsonsName: "",
            stationsId: "",

            //审批人不正常
            undoorsId: "",
            undoorsName: "请选择部门",
            unprsonsId: "",
            unprsonsName: "",
            approveName: "",
            departmentList: [], //部门列表
            undepartmentList: [], //非正常部门列表
            personList: [], //人员列表
            unpersonList: [], //非正常人员列表
            stationList: [], //岗位列表
            conditionList: [], //条件申请人列表
            conditionprsonList: [],//当前已选择申请人
            conditionItem: {},//条件申请人
            dataList: {
                stationName: "", //岗位名称
                employeeRole: "EMPLOYEE", //审批类型
                checkEmployeeIds: [], //人员列表ID
                stationId: "", //岗位ID
                approverList: [],
                checkType: "AND",
                employeeIfNull: "AGREE",
                undoorsId: "",
                undoorsName: "请选择部门",
                adminId: ""
            },
            drawer: false,
            drawer2: false,
            direction: "rtl",
            allIn: "",
            allIndb: "",
            conditionIndex: "",
            search: {
                type: "请假",//类型
                name: "",//名称
                remarks: "",//备注
                applyType: "1",//申请人
                list: [
                    {
                        stationName: "", //岗位名称
                        employeeRole: "EMPLOYEE", //审批类型
                        checkEmployeeIds: [], //人员列表ID
                        stationId: "", //岗位ID
                        approverList: [],
                        checkType: "AND",
                        employeeIfNull: "AGREE",
                        undoorsId: "",
                        undoorsName: "请选择部门",
                        adminId: ""
                    }
                ],
                checkJson: [
                    {
                        conditionRemarks: "条件1",//title名称
                        employeeIds: [],//条件人
                        employeeIdNames: [],
                        edititle: false,
                        list: [
                            {
                                stationName: "", //岗位名称
                                employeeRole: "EMPLOYEE", //审批类型
                                checkEmployeeIds: [], //人员列表ID
                                stationId: "", //岗位ID
                                approverList: [],
                                checkType: "AND",
                                employeeIfNull: "AGREE",
                                undoorsId: "",
                                undoorsName: "请选择部门",
                                adminId: ""
                            }
                        ]
                    },

                ]

            }
        };
    },
    mounted() {
        if (this.setId) {
            this.querySetDetail(); //根据审批编号查询审批流配置
        }
        this.getstationList(); //查询岗位
        this.departmentFind(); //查询申请人
        this.getdepartmentFind(); //查询部门

    },
    // watch: {
    //     search: {
    //         handler(newValue, oldValue) {
    //             this.itemWidth = this.search.checkJson.length * 240 - 240 + 2;
    //         },
    //         deep: true
    //     }
    // },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    methods: {
        /* 根据审批编号查询审批流配置 */
        querySetDetail() {
            let params = {
                id: this.setId
            };
            this.$post(queryDetail, params).then(res => {
                if (res.success) {
                    this.search = res.data;
                    this.itemWidth = this.search.checkJson.length * 240 - 240 + 2;
                }
            });
        },
        /* 保存审批 */
        saveChecking() {
            if (!this.search.name) {
                this.$message.error("名称不能为空");
                return;
            }
            if (this.setId) {
                this.editChecking();
            } else {
                this.addChecking();
            }
        },
        /* 新增审批 */
        addChecking() {
            let params = Object.assign({}, this.search);
            params.list = JSON.stringify(params.list);
            params.checkJson = JSON.stringify(params.checkJson);
            this.$post(addCheck, params).then(res => {
                if (res.success) {
                    this.$message({
                        type: "success",
                        message: res.msg
                    });
                    this.$store.commit("delete_tabs", this.$route.path);
                    this.$router.push("/approvalSet");
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            });
        },
        /* 编辑审批 */
        editChecking() {
            let params = Object.assign({}, this.search);
            params.list = JSON.stringify(params.list);
            params.checkJson = JSON.stringify(params.checkJson);
            this.$post(updateSet, params).then(res => {
                if (res.success) {
                    this.$message({
                        type: "success",
                        message: res.msg
                    });
                    this.$store.commit("delete_tabs", this.$route.path);
                    this.$router.push("/approvalSet");
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            });
        },
        /* 通过图标关闭考勤人员弹框 */
        handleClose(done) {
            this.employeeIds = [];
            done();
        },
        /* 删除考勤人员 */
        deleteAttendancePerson(index) {
            this.employeeIds.splice(index, 1);
        },
        /* 查询考勤人员 */
        departmentFind() {
            this.$post(departmentFind1).then(res => {
                if (res.success) {
                    this.attendancePerson = res.data;
                    this.changeDate();
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            });
        },
        /* 模糊搜索考勤人员 */
        filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        /* 选择考勤人员 */
        choicePerson(val) {
            if (!val.hasOwnProperty("child")) {
                // if (this.employeeIds.length == 0) {
                //     this.employeeIds.push(val);
                // } else {
                //     let people = {};
                //     for (var i = 0; i < this.employeeIds.length; i++) {
                //          if (this.employeeIds[i].id !== val.id) {
                //             return;
                //         }else{
                //             people = val
                //         }
                //     }
                //      this.employeeIds.push(people);
                // }
                let arr = [];
                this.employeeIds.map(item => {
                    arr.push(item.id)
                })
                if (arr.indexOf(val.id) === -1) {
                    this.employeeIds.push(val);
                }
            } else {
                if (val.child.length > 0) {
                    val.child.map(item => {
                        this.call(item);
                    });
                }
            }
        },
        call(item) {
            if (!item.hasOwnProperty("child")) {
                // if (this.employeeIds.length == 0) {
                //     this.employeeIds.push(item);
                // } else {
                //     let people = {};
                //     for (var i = 0; i < this.employeeIds.length; i++) {
                //          if (this.employeeIds[i].id == item.id) {
                //             return;
                //         }else{
                //             people = item
                //         }
                //     }
                //      this.employeeIds.push(people);
                // }
                let arr = [];
                this.employeeIds.map(item => {
                    arr.push(item.id)
                })
                if (arr.indexOf(item.id) === -1) {
                    this.employeeIds.push(item);
                }
            } else {
                if (item.child.length > 0) {
                    item.child.map(item => {
                        this.call(item);
                    });
                }
            }
        },
        changeDate() {
            this.attendancePerson.map(item => {
                if (item.hasOwnProperty("employees") && item.employees.length !== 0) {
                    item.employees.map(item1 => {
                        item.child.push(item1);
                    });
                }
                if (item.hasOwnProperty("child") && item.child.length !== 0) {
                    this.callchangeDate(item.child);
                }
            });
        },
        callchangeDate(obj) {
            obj.map(item => {
                if (item.hasOwnProperty("employees") && item.employees.length !== 0) {
                    item.employees.map(item1 => {
                        item.child.push(item1);
                    });
                }
                if (item.hasOwnProperty("child") && item.child.length !== 0) {
                    this.callchangeDate(item.child);
                }
            });
        },
        /* 新增条件 */
        addCondition() {
            let conditionItem = {
                conditionRemarks: "条件" + (this.search.checkJson.length + 1),//title名称
                employeeIds: [],//条件人
                employeeIdNames: [],
                edititle: false,
                list: [
                    {
                        stationName: "", //岗位名称
                        employeeRole: "EMPLOYEE", //审批类型
                        checkEmployeeIds: [], //人员列表ID
                        stationId: "", //岗位ID
                        approverList: [],
                        checkType: "AND",
                        employeeIfNull: "AGREE",
                        undoorsId: "",
                        undoorsName: "请选择部门",
                        adminId: ""
                    }
                ]
            }
            this.search.checkJson.push(conditionItem);
            this.itemWidth = this.search.checkJson.length * 240 - 240 + 2;
        },
        /* 修改名字 */
        editText(index) {
            this.search.checkJson[index].edititle = true;
            this.$nextTick(() => {
                this.$refs.inputFocus[0].focus();
            })

        },
        okText(index) {
            this.search.checkJson[index].edititle = false;
            if (this.$refs.inputFocus[0].value) {
                this.search.checkJson[index].conditionRemarks = this.$refs.inputFocus[0].value;
            } else {
                this.search.checkJson[index].conditionRemarks = "条件" + (index + 1);
            }
        },
        /* 删除审批人 */
        delectList(index, index1) {
            if (this.search.applyType == "1") {
                this.search.list.splice(index, 1);
            } else {
                this.search.checkJson[index].list.splice(index1, 1);
            }
        },
        /* 删除条件审批人 */
        delectTable(index) {
            this.$confirm("您确认要删除该条件配置吗？", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                center: true
            }).then(() => {
                //确定删除
                this.search.checkJson.splice(index, 1);
                this.itemWidth = this.search.checkJson.length * 240 - 240 + 2;
            });

        },
        /* 新增审批人 */
        addList(index) {
            let over1 = false;
            let over2 = false;
            let dataListLength = this.search.list.length - 1;
            if (this.search.applyType == "1") {
                if (this.search.list[dataListLength].employeeRole == "EMPLOYEE") {
                    if (this.search.list[dataListLength].checkEmployeeIds.length == 0) {
                        this.$message({
                            type: "error",
                            message: "审批人不能为空"
                        });
                        return;
                    } else {
                        over1 = true;
                    }
                } else if (this.search.list[dataListLength].employeeRole == "ROLE") {
                    if (!this.search.list[dataListLength].stationId) {
                        this.$message({
                            type: "error",
                            message: "岗位不能为空"
                        });
                        return;
                    } else {
                        over1 = true;
                    }
                }
                if (this.dataList.employeeIfNull == "DISAGREE") {
                    if (!this.dataList.adminId) {
                        this.$message({
                            type: "error",
                            message: "指定人员不能为空"
                        });
                        return;
                    } else {
                        over2 = true;
                    }
                } else if (this.dataList.employeeIfNull == "AGREE") {
                    over2 = true;
                }
            } else {
                let listLength = this.search.checkJson[index].list.length - 1;
                if (this.search.checkJson[index].list[listLength].employeeRole == "EMPLOYEE") {
                    if (this.search.checkJson[index].list[listLength].checkEmployeeIds.length == 0) {
                        this.$message({
                            type: "error",
                            message: "审批人不能为空"
                        });
                        return;
                    } else {
                        over1 = true;
                    }
                } else if (this.search.checkJson[index].list[listLength].employeeRole == "ROLE") {
                    if (!this.search.checkJson[index].list[listLength].stationId) {
                        this.$message({
                            type: "error",
                            message: "岗位不能为空"
                        });
                        return;
                    } else {
                        over1 = true;
                    }
                }
                if (this.search.checkJson[index].list[listLength].employeeIfNull == "DISAGREE") {
                    if (!this.search.checkJson[index].list[listLength].adminId) {
                        this.$message({
                            type: "error",
                            message: "指定人员不能为空"
                        });
                        return;
                    } else {
                        over2 = true;
                    }
                } else if (this.search.checkJson[index].list[listLength].employeeIfNull == "AGREE") {
                    over2 = true;
                }
            }
            if (over1 && over2) {
                let item = {
                    stationName: "", //岗位名称
                    employeeRole: "EMPLOYEE",
                    checkEmployeeIds: [],
                    stationId: "",
                    checkType: "AND",
                    employeeIfNull: "AGREE",
                    undoorsId: "",
                    undoorsName: "请选择部门",
                    adminId: "",
                    approverList: []
                };
                if (this.search.applyType == "1") {
                    this.search.list.push(item);
                } else {
                    this.search.checkJson[index].list.push(item);
                }
                this.dataList = {
                    stationName: "", //岗位名称
                    employeeRole: "EMPLOYEE", //审批类型
                    checkEmployeeIds: [], //人员列表ID
                    stationId: "", //岗位ID
                    approverList: [],
                    checkType: "AND",
                    employeeIfNull: "AGREE",
                    undoorsId: "",
                    undoorsName: "请选择部门",
                    adminId: ""
                };
            }
        },
        /* 选择部门审批人 */
        addApprover(val) {
            if (this.dataList.checkEmployeeIds.indexOf(val) > -1) {
                this.$message({
                    type: "error",
                    message: "该审批人已存在"
                });
            } else {
                this.personList.map((item, index) => {
                    if (val == item.id) {
                        this.dataList.approverList.push(
                            item.departmentName + "-" + item.name
                        );
                        this.dataList.checkEmployeeIds.push(item.id);
                    }
                });
            }
        },
        /* 删除部门审批人 */
        deleteApprover(index) {
            this.dataList.approverList.splice(index, 1);
            this.dataList.checkEmployeeIds.splice(index, 1);
        },
        /* 选择岗位 */
        addStations(val) {
            this.stationList.map((item, index) => {
                if (val == item.roleId) {
                    this.dataList.stationName = item.name;
                }
            });
        },
        /* 提价侧栏数据 */
        okClick() {
            if (this.search.applyType == "1") {
                if (this.dataList.employeeRole == "EMPLOYEE") {
                    if (this.dataList.checkEmployeeIds.length == 0) {
                        this.$message({
                            type: "error",
                            message: "审批人不能为空"
                        });
                        return;
                    }
                } else if (this.dataList.employeeRole == "ROLE") {
                    if (!this.dataList.stationId) {
                        this.$message({
                            type: "error",
                            message: "岗位不能为空"
                        });
                        return;
                    }
                }
                if (this.dataList.employeeIfNull == "DISAGREE") {
                    if (!this.dataList.adminId) {
                        this.$message({
                            type: "error",
                            message: "指定人员不能为空"
                        });
                        return;
                    }
                }
                this.search.list[this.allIn] = this.dataList;
            } else if (this.search.applyType == "2") {
                if (this.dataList.employeeRole == "EMPLOYEE") {
                    if (this.dataList.checkEmployeeIds.length == 0) {
                        this.$message({
                            type: "error",
                            message: "审批人不能为空"
                        });
                        return;
                    }
                } else if (this.dataList.employeeRole == "ROLE") {
                    if (!this.dataList.stationId) {
                        this.$message({
                            type: "error",
                            message: "岗位不能为空"
                        });
                        return;
                    }
                }
                if (this.dataList.employeeIfNull == "DISAGREE") {
                    if (!this.dataList.adminId) {
                        this.$message({
                            type: "error",
                            message: "指定人员不能为空"
                        });
                        return;
                    }
                }
                this.search.checkJson[this.allIn].list[this.allIndb] = this.dataList;
            }
            this.drawer = false;
        },
        conditionOkClick() {
            if (this.search.applyType == "2") {
                if (this.employeeIds && this.employeeIds.length == 0) {
                    this.$message({
                        type: "error",
                        message: "申请人不能为空"
                    });
                    return;
                } else {
                    let arr = Object.assign([], this.employeeIds);
                    let arrName = [];
                    arr.map((item, index) => {
                        arrName.push(item.name);
                    })
                    this.conditionItem.employeeIds = arr;
                    this.conditionItem.employeeIdNames = arrName;
                    this.search.checkJson[this.conditionIndex] = this.conditionItem;
                    this.drawer2 = false;
                }

            }

        },
        /* 单选审批类型 */
        radioClick(value) {
            this.dataList.stationId = "";
            this.dataList.checkEmployeeIds = [];
            this.dataList.approverList = [];
            this.dataList.stationId = "";
        },
        /* 选择部门 */
        handleNodeClick(node, data) {
            //cosole.log(node)
            this.doorsId = node.id;
            this.doorsName = node.name;
            this.prsonsId = "";
            this.departpopshow = false;
        },
        /* 非正常选择部门 */
        UnhandleNodeClick(node, data) {
            this.dataList.undoorsId = node.id;
            this.dataList.undoorsName = node.name;
            this.dataList.adminId = "";
            this.departpopshow1 = false;
        },
        /* 查询部门 */
        getdepartmentFind() {
            this.$post(departmentFind).then(res => {
                if (res.success) {
                    this.departmentList = res.data;
                    this.undepartmentList = res.data;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            });
        },
        /* 查询人员 */
        getPrson(val) {
            if (val) {
                if (!this.doorsId) {
                    this.$message({
                        type: "error",
                        message: "请选择部门"
                    });
                    return;
                } else {
                    let params = {
                        departmentId: this.doorsId,
                        status:'ENABLE'
                    };
                    this.$post(queryEmployeeNameByStoreId, params).then(res => {
                        if (res.success) {
                            this.personList = res.data;
                        } else {
                            this.$message({
                                type: "error",
                                message: res.msg
                            });
                        }
                    });
                }
            }
        },
        /* 非正常查询人员 */
        ungetPrson(val) {
            if (val) {
                if (!this.dataList.undoorsId) {
                    this.$message({
                        type: "error",
                        message: "请选择部门"
                    });
                    return;
                } else {
                    let params = {
                        departmentId: this.dataList.undoorsId,
                        status:'ENABLE'
                    };
                    this.$post(queryEmployeeNameByStoreId, params).then(res => {
                        if (res.success) {
                            this.unpersonList = res.data;
                        } else {
                            this.$message({
                                type: "error",
                                message: res.msg
                            });
                        }
                    });
                }
            }
        },
        /* 查询岗位 */
        getstationList() {
            let params = {
                status: "ENABLE"
            };
            this.$post(find, params).then(res => {
                if (res.success) {
                    this.stationList = res.data;
                }
            });
        },
        /* 查询条件申请人 */
        getconditionPrson(queryString, cb) {
            let params = {
                name: queryString,
                status:'ENABLE',
            };
            this.$post(employeeQuery, params).then(res => {
                if (res.success) {
                    this.conditionList = res.data;
                    for (let i = 0; i < this.search.checkJson.length; i++) {
                        this.conditionprsonList = this.conditionprsonList.concat(this.search.checkJson[i].employeeIdNames);
                    }
                    if (this.conditionprsonList.length > 0) {
                        this.conditionprsonList.map((item, index) => {
                            this.conditionList.map((item1, index1) => {
                                if (item == item1.name) {
                                    this.conditionList.splice(index1, 1)
                                }
                            })
                        })
                    }
                    let restaurants = this.conditionList;
                    cb(restaurants);
                }
            });
        },
        /* 打开当项 */
        itemClick(item, index, index1) {
            // this.dataList = Object.assign({}, item)
            this.dataList = JSON.parse(JSON.stringify(item));
            if (this.dataList.undoorsId) {
                this.ungetPrson(true);
            }
            this.doorsId = "";
            this.doorsName = "请选择部门";
            this.prsonsId = "";
            this.prsonsName = "";
            this.drawer = true;
            this.allIn = index;
            this.allIndb = index1;
        },
        /* 打开条件申请人 */
        conditionClick(item, index) {
            this.conditionItem = Object.assign({}, item);
            this.employeeIds = Object.assign([], item.employeeIds);
            this.drawer2 = true;
            this.filterText = "";
            this.conditionIndex = index;
        }

    }
};
</script>

<style lang='less'>
.checkingSet {
    background: #fff;
    padding: 30px 34px;
    min-height: 100%;
    width: 100%;
    overflow: auto;
    .checkingSet_wrap {
        .checkingSet_title {
            // width: 25%;
            .key_list {
                display: flex;
                .conditions_list_item {
                    background: #f5f5f5;
                    padding: 0 10px;
                    display: flex;
                    align-items: center;
                    margin-right: 20px;
                    position: relative;
                    overflow: hidden;
                    cursor: pointer;
                    > .icon_text {
                        line-height: 20px;
                        border-right: 1px solid #ccc;
                        font-size: 14px;
                        color: #5e75e6;
                        padding: 0;
                        padding-right: 10px;
                    }
                    > .icon_red {
                        color: red;
                        border-right: 0;
                        padding: 0;
                        padding-right: 2px;
                    }
                    .el-input {
                        width: 120px;
                        height: 30px;
                        .el-input__inner {
                            border: none;
                            height: 30px;
                            background: #f5f5f5;
                        }
                    }
                    // .el-select {
                    //     margin-left: 10px;
                    //     .el-input {
                    //         width: 100px;
                    //         .el-input__inner {
                    //             width: 100px;
                    //             height: 30px;
                    //             border: none;
                    //             background: #f5f5f5;
                    //             color: black;
                    //             padding: 0;
                    //         }
                    //     }
                    // }
                }
            }
            .key_list_b {
                margin-top: 20px;
                .conditions_list_item {
                    display: flex;
                    margin-bottom: 20px;
                    .span_title {
                        font-size: 14px;
                        min-width: 42px;
                    }
                    .el-textarea {
                        .el-textarea__inner {
                            background: #f5f5f5;
                            border: none;
                            width: 354px;
                        }
                    }
                    .radio_style {
                        display: flex;
                        flex-direction: column;
                        .el-radio {
                            margin-bottom: 20px;
                        }
                    }
                }
            }
        }
        .checkingSet_content {
            font-size: 14px;
            display: flex;
            .checkingSet_content_title {
                .xing {
                    color: red;
                }
            }
            .checkingSet_content_wrap {
                .wrap_item {
                    .all {
                        &.allIn {
                            border: 1px solid #5e75e6;
                            border-radius: 4.5px 4.5px 0 0;
                            box-shadow: 0px 0px 5px #999;
                        }
                        .top {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 0 5px;
                            width: 220px;
                            height: 24px;
                            border-radius: 4px 4px 0 0;
                            background: #ff943e;
                            color: #fff;
                            .top_left {
                                display: flex;
                                .iconfont {
                                    font-size: 14px;
                                }
                            }

                            .top_right {
                                cursor: pointer;
                            }
                        }
                        .bottom {
                            display: flex;
                            justify-content: space-between;
                            padding: 0 5px;
                            width: 220px;
                            height: 50px;
                            background: #f5f5f5;
                            line-height: 50px;
                            color: #999999;
                            cursor: pointer;
                            .iconfont {
                                font-size: 14px;
                                margin-right: 10px;
                            }
                        }
                    }

                    .more {
                        text-align: center;
                    }
                }
                .wrap_item:nth-last-child(2) {
                    .more {
                        display: none;
                    }
                }
                .wrap_item_add {
                    width: 220px;
                    height: 74px;
                    text-align: center;
                    position: relative;
                    .iconfont {
                        color: #3296fa;
                        font-size: 28px;
                        position: absolute;
                        top: 50%;
                        margin-top: -13px;
                        left: 50%;
                        margin-left: -13px;
                        cursor: pointer;
                    }
                }
            }
        }
        .dbcheckingSet_content {
            font-size: 14px;
            display: flex;

            .checkingSet_content_title {
                .xing {
                    color: red;
                }
            }
            .checkingSet_content_wrap {
                .content_wrap_button {
                    margin: 0 auto;
                    text-align: center;
                    width: 150px;
                    height: 42px;
                    line-height: 42px;
                    color: #fff;
                    background: #5d78ff;
                    box-shadow: 0px 1px 9px 0px rgba(87, 115, 255, 0.52);
                    border-radius: 4px;
                    cursor: pointer;
                }
                .content_wrap_button_line {
                    text-align: center;
                }
                .content_wrap_item {
                    .button_line {
                        // border-top: 2px solid #cacaca;
                        text-align: center;
                    }
                    .wrap_item {
                        padding: 0 10px;
                        .all {
                            &.allIn {
                                border: 1px solid #5e75e6;
                                border-radius: 4.5px 4.5px 0 0;
                                box-shadow: 0px 0px 5px #999;
                            }
                            .top {
                                display: flex;
                                justify-content: space-between;
                                padding: 0 5px;
                                width: 220px;
                                height: 24px;
                                border-radius: 4px 4px 0 0;
                                background: #ff943e;
                                align-items: center;
                                color: #fff;
                                .top_left {
                                    display: flex;
                                    align-items: center;
                                    .iconfont {
                                        font-size: 14px;
                                        width: 14px;
                                        height: 14px;
                                    }
                                    .input_text {
                                        margin: 0 10px;
                                    }
                                    .input_text1 {
                                        margin: 0 10px;
                                        width: 100px;
                                        input {
                                            width: 100%;
                                        }
                                        input:focus {
                                            outline: none;
                                            border: none;
                                        }
                                    }
                                }
                                .top_right {
                                    cursor: pointer;
                                }
                            }
                            .bottom {
                                display: flex;
                                justify-content: space-between;
                                padding: 0 5px;
                                width: 220px;
                                height: 50px;
                                background: #f5f5f5;
                                line-height: 50px;
                                color: #999999;
                                cursor: pointer;
                                .iconfont {
                                    font-size: 14px;
                                    margin-right: 10px;
                                }
                            }
                        }

                        .more {
                            text-align: center;
                        }
                    }
                    .wrap_item:nth-last-child(1) {
                        .top {
                            display: flex;
                            justify-content: space-between;
                            padding: 0 5px;
                            width: 220px;
                            height: 24px;
                            border-radius: 4px 4px 0 0;
                            background: #01ce88;
                            align-items: center;
                            color: #fff;
                            .top_right {
                                cursor: pointer;
                            }
                        }
                        .bottom {
                            .bottom_left {
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }
                        }
                    }
                    .wrap_item:nth-last-child(2) {
                        .more {
                            display: none;
                        }
                    }
                    .wrap_item_add {
                        width: 240px;
                        height: 74px;
                        text-align: center;
                        position: relative;
                        .iconfont {
                            color: #3296fa;
                            font-size: 28px;
                            position: absolute;
                            top: 50%;
                            margin-top: -13px;
                            left: 50%;
                            margin-left: -13px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
    .el-drawer:focus {
        outline: none;
    }
    .drawer {
        margin: 30px;
        .btns {
            display: flex;
            width: 100%;
            justify-content: center;
            margin-top: 200px;
            .btn_left {
                width: 150px;
                height: 40px;
                background: #bbbbbb;
                color: #fff;
                font-size: 14px;
                line-height: 40px;
                text-align: center;
                border-radius: 3px;
                cursor: pointer;
                margin-right: 20px;
            }
            .btn_right {
                width: 150px;
                height: 40px;
                background: #5e75e6;
                color: #fff;
                font-size: 14px;
                line-height: 40px;
                text-align: center;
                border-radius: 3px;
                cursor: pointer;
            }
        }
        .drawer_text {
            font-size: 14px;
            padding: 0;
            margin: 0;
            list-style: none;
            .drawer_text_item {
                margin-bottom: 25px;
                .el-select {
                    margin-left: 10px;
                    .el-input {
                        width: 144px;
                        .el-input__inner {
                            width: 144px;
                            height: 30px;
                            border: none;
                            background: #f5f5f5;
                            color: black;
                        }
                    }
                }
                .staffmsg {
                    width: 144px;
                    height: 30px;
                    background: #f5f5f5;
                    border-radius: 3px;
                    line-height: 30px;
                    font-size: 14px;
                    .staffmsg_ipt {
                        padding-left: 15px;
                    }
                    .departpop {
                        .el-tree {
                            z-index: 99;
                        }
                    }
                }
                .name {
                    margin-bottom: 20px;
                    display: flex;
                    align-items: center;
                }
                .val {
                    display: flex;
                    .val_item {
                        margin-right: 30px;
                        position: relative;
                        .val_item_img {
                            position: absolute;
                            top: -7px;
                            right: -14px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
    .el-dialog {
        .el-dialog__header {
            padding: 20px 30px 0 30px;
        }
        .el-dialog__body {
            .el-time-panel__footer {
                .cancel {
                    background: none !important;
                    color: #333 !important;
                    font-size: 12px !important;
                }
            }
            .out1 {
                padding: 20px 30px 0 30px;
                .el-input__inner {
                    width: 200px;
                }
                .title_text {
                    display: flex;
                    margin-top: 30px;
                    line-height: 30px;
                    justify-content: space-between;
                    .text_right {
                        display: flex;
                        align-items: center;
                    }
                    span {
                        font-size: 14px;
                        font-weight: bold;
                    }
                }
                .tree-title {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;
                    .el-input {
                        width: 200px;
                    }
                    div {
                        min-width: 68px;
                    }
                }
                .tree_out {
                    display: flex;
                    justify-content: space-between;
                    .el-tree,
                    .selected {
                        padding: 10px;
                        width: 200px;
                        height: 260px;
                        border: 1px solid #dcdfe6;
                        overflow-y: auto;
                    }
                    .selected {
                        width: 180px;
                        line-height: 1.8;
                        padding: 10px 15px;
                        .selected-item {
                            display: flex;
                            justify-content: space-between;
                        }
                        .icon-guanbi {
                            color: #999999;
                            margin-left: 30px;
                            cursor: pointer;
                        }
                    }
                }
            }
            .clockinout {
                padding: 20px 30px 0 30px;
                .el-input__inner {
                    width: 220px;
                    padding-left: 30px;
                }
            }
            .dateOut {
                padding: 20px 30px 0 30px;
                .el-input {
                    width: 120px;
                    height: 26px;
                    margin: 0 6px;
                    .el-input__prefix {
                        display: none;
                    }
                    .el-input__suffix {
                        right: 1px;
                        top: 1px;
                    }
                    .el-input__inner {
                        padding: 0 10px;
                        height: 26px;
                    }
                }
                .item {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    margin-bottom: 20px;
                    .label {
                        width: 110px;
                        text-align: right;
                        /*margin-top: 2px;*/
                        .must {
                            color: #ff0000;
                            margin-right: 2px;
                        }
                    }
                    .clockin,
                    .clockout {
                        margin-right: 20px;
                        .el-input {
                            width: 70px;
                        }
                    }
                    .dlatetime {
                        width: 78px;
                        margin: 0 6px;
                        .el-input__inner {
                            width: 78px;
                        }
                    }
                    .el-checkbox {
                        margin-right: 16px;
                    }
                    .el-radio-button__inner {
                        height: 30px;
                        line-height: 30px;
                        padding: 0 15px;
                    }
                    .el-radio-button__orig-radio:checked
                        + .el-radio-button__inner {
                        background: #5e75e6;
                    }
                }
            }
            .dialog-foot {
                text-align: right;
                margin-top: 50px;
                background: #f5f5f5;
                padding: 20px;
                .foot-cancel,
                .foot-save {
                    width: 80px;
                    height: 40px;
                    border: none;
                    outline: none;
                    border-radius: 4px;
                    font-size: 16px;
                    color: #ffffff;
                    margin-right: 20px;
                }
                .foot-cancel {
                    background: #cccccc;
                }
                .foot-save {
                    background: #5e75e6;
                }
            }
        }
    }
    .submitOk {
        width: 150px;
        height: 40px;
        background: #5e75e6;
        color: #fff;
        font-size: 14px;
        line-height: 40px;
        text-align: center;
        border-radius: 3px;
        cursor: pointer;
        margin: 50px auto;
    }
}
</style>